import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-3 py-1.5 text-sm font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-success-10 text-success-70',
        secondary: 'bg-gray-10 text-gray-60',
        destructive: 'bg-destructive-40 text-white',
        outline: 'border border-gray-30 text-gray-60',
        brand: 'bg-brand-10 text-brand-90',
        orange: 'bg-orange-10 text-orange-70',
        teal: 'bg-teal-10 text-teal-50',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
